import type { UseMutationResult } from "@tanstack/react-query"

import { useSolarConcertStatusCommand } from "./solar-concert-application-cache"
import type {
  SolarConcertApplicationStatusDto,
  SolarConcertLoanDocumentDelivery,
} from "../dto/solar-concert.dto"
import { solarProposalService } from "../services/solar-proposal.service"

/**
 * Send the loan documents (Concert's main contract) for signature, by email
 * unless the seller asks for in person. The server holds the claim, so a
 * retry cannot email the homeowner twice.
 */
export default function useSendSolarConcertLoanDocuments(): UseMutationResult<
  SolarConcertApplicationStatusDto,
  unknown,
  { proposalId: string; method?: SolarConcertLoanDocumentDelivery }
> {
  return useSolarConcertStatusCommand(({ proposalId, method }) =>
    solarProposalService.sendConcertLoanDocuments(proposalId, method),
  )
}
